query getStockPhotos($input: GetStockPhotosInput!) {
  stockPhotos: getStockPhotos(input: $input) {
    photos {
      id
      fileId
      width
      height
      url
      avg_color
      canBeDownloaded
      isLicenseRequired
      history {
        id
        type
        timestamp
        userId
      }
      src {
        original
        large2x
        large
        medium
        small
        portrait
        landscape
        tiny
        __typename
      }
      __typename
    }
    total_results
    page
    per_page
    __typename
  }
}
